module.exports = __webpack_public_path__ + "img/ic_process_brand.fcc5565a.png";